import { render } from "./Step.vue?vue&type=template&id=29038f12&scoped=true&ts=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"

import "./Step.vue?vue&type=style&index=0&id=29038f12&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29038f12"]])

export default __exports__